<template>
   <div class="loading-container" style="text-align: center; margin-top: 100px;">
        <i class="fa-sharp fa-thin fa-spinner-third loading-spinner"></i>
        <p>Carregando...</p>
  </div>
</template>
<script>
export default {
  name: "Loading"
}
</script>

<style>

.loading-spinner {
      font-size: 20px; /* Tamanho do ícone */
      color: rgba(0,0,0,.4); /* Cor do ícone */
      animation: spin 0.7s linear infinite; /* Animação de rotação */
    }

    /* Animação de rotação */
    @keyframes spin {
      from {
        transform: rotate(0deg); /* Começa sem rotação */
      }
      to {
        transform: rotate(360deg); /* Rotação completa */
      }
    }

</style>